import { hc } from "hono/client"

import type { AppType } from "@shared/types"

// /api/search is called with plain fetch instead of hc — its agentic branch
// returns a raw SSE Response, which defeats hc's inference for the whole route.
export const client = hc<AppType>("/")
